





























import { Component, Vue } from 'vue-property-decorator';
// import { Route } from 'vue-router';
// import {
//   GetClientsRequestSortByEnum,
//   GetClientsRequestSortOrderEnum,
//   GetClientsRequest,
//   GetClientsRequestClientTypeEnum,
// } from '@/api';
// import services from '@/services';
import { clientsModule, compilationsModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';

@Component({
  name: 'compilation-root-page',
  components: {
    UserMenu,
    MainNavbar,
  },
})
export default class compilationRoot extends Vue {
  get client() {
    return clientsModule.model;
  }

  get compilation() {
    return compilationsModule.model;
  }

  created() {
    const { compilationId, clientId } = this.$route.params;
    compilationsModule
      .fetchCompilation({ compilationId: Number(compilationId) });
    clientsModule.fetchStylists();

    clientsModule.fetchInfo(Number(clientId));
  }
}
